import { render, staticRenderFns } from "./SelectProfessionUpdate.vue?vue&type=template&id=6b55a388&scoped=true"
import script from "./SelectProfessionUpdate.vue?vue&type=script&lang=ts"
export * from "./SelectProfessionUpdate.vue?vue&type=script&lang=ts"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./SelectProfessionUpdate.vue?vue&type=style&index=1&id=6b55a388&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b55a388",
  null
  
)

export default component.exports